import Vue from 'vue';
const getRefreshTokenExpirationDate = token => new Date(new Date().getTime() + token.refresh_expires_in * 1000);

export const setToken = token => {
    if (token) {
        delete token['unit_authorities'];
        Vue.cookie.set('javaToken', JSON.stringify(token), {
            expires: getRefreshTokenExpirationDate(token),
            domain: '.braster.eu',
        });
    }
};
export const getToken = () => {
    const token = Vue.cookie.get('javaToken');
    return token ? JSON.parse(token) : null;
};
export const getRolesFromToken = () => {
    const token = getToken();
    const rolesFromToken = token != null ? token.authorities.map(i => (i.includes('/') ? i.split('/')[0] : i)) : [];
    console.log(rolesFromToken);
    return rolesFromToken;
};
export const removeToken = () => {
    Vue.cookie.set('javaToken', '', { domain: '.braster.eu' });
    Vue.cookie.delete('javaToken');
};

export const checkToken = token => {
    var base64Url = token.access_token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join(''),
    );

    const rawToken = JSON.parse(jsonPayload);
    return rawToken.server_url;
};



// WEBPACK FOOTER //
// ./src/assets/js/tokenUtils.js